import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import debounce from 'lodash/debounce'

import { TextField } from 'discada/dist/Form'

import { SelectField } from 'discada/dist/Form'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { getRooftopWebsite } from 'selectors/appStatusSelectors'
import { updateTrade } from 'actions/naughtyActions'

import {
  getCustomerZip,
  getCustomerHasNoTrade,
} from 'selectors/naughtySelectors'

import {
  getYMMT,
  tradeIsValid,
  getTradeChoices,
  searchTrade,
} from 'utils/trade'

import './TradePendingSearch.scss'

export function TradePendingSearchNewPreso(props) {
  let {
      tradeKey,
      hasNoTrade,
      trade = {},
      updateTrade,
      children,
      dealerWebsite,
      createChangeEvent,
    } = props,
    { year, make, model, trim } = trade,
    [tradeIndex, setTradeIndex] = useState(props.tradeIndex),
    [ymmt, setYmmt] = useState(props.ymmt),
    [mileage, setMileage] = useState(trade.mileage),
    [results, setResults] = useState([]),
    [resultsOk, setResultsOk] = useState(false),
    [choices, setChoices] = useState([]),
    getResults = useCallback(
      debounce(ymmt => {
        searchTrade(dealerWebsite, ymmt).then(({ data }) => setResults(data))
      }, 100),
      [ymmt],
    ),
    onSelect = useCallback(
      (vehicle = {}, clearTrade) => {
        updateTrade(
          tradeIndex,

          { ...vehicle, tradePending: { vehicle } },
          { createChangeEvent, clearTrade },
        )
        setResults([])
        setResultsOk(false)
      },
      [createChangeEvent, tradeIndex, updateTrade],
    ),
    tpId = get(trade, 'tradePending.vehicle.id') || get(trade, 'id')

  useEffect(() => {
    setTradeIndex(props.tradeIndex)
  }, [props.tradeIndex])

  // when there's a change that can affect choices, get new ones, otherwise
  // reset the choice options, try to match to an existing one first though
  useEffect(() => {
    let vehicle = { year, make, model, trim }

    if (!isEmpty(dealerWebsite) && tradeIsValid(vehicle)) {
      getTradeChoices({ dealerWebsite, vehicle }).then(({ data }) => {
        let { details = [] } = data,
          value = details.find(d => tpId === d.id)

        setChoices(details)

        if (value) onSelect(value)
        else if (details.length === 1) onSelect(details[0])
        else
          onSelect(
            {
              ...vehicle,
              id: null,
            },
            true,
          )
      })
    } else {
      setChoices([])
    }
  }, [dealerWebsite, year, make, model, trim])

  // get ymmt value on any trade data change
  useEffect(() => {
    setYmmt(getYMMT({ year, make, model, trim, ymmt: trade.ymmt }))
  }, [make, model, trade.ymmt, trim, year])

  //search on ymmt changes
  useEffect(() => {
    resultsOk && ymmt && getResults(ymmt)
  }, [ymmt, resultsOk, getResults])

  // reset if text entry removed
  useEffect(() => {
    if (isEmpty(ymmt)) {
      setResults([])
      setChoices([])

      onSelect({ id: null })
    }
  }, [ymmt])

  return (
    <div className="tradepending-search">
      <div className="tradepending-search-wrapper">
        <TextField
          rounded
          leftIcon="car"
          type="text"
          key={tradeKey}
          disabled={hasNoTrade}
          required
          label="What do you drive?"
          className="trade-pending"
          placeholder="Enter Year, Make, Model..."
          value={ymmt}
          onChange={({ target }) => setYmmt(target.value)}
          onFocus={({ target }) => {
            target.select()
            setResultsOk(true)
          }}
        />
        {resultsOk && results.length > 0 && (
          <ul className="tradepending-search-results">
            {results.map((r, i) => (
              <li key={i} onClick={() => onSelect(r)}>
                {getYMMT(r)}
              </li>
            ))}
          </ul>
        )}
      </div>
      {choices.length > 1 && (
        <SelectField
          rounded
          className="tradepending-option"
          size="small"
          value={trade.id}
          onChange={({ target }) =>
            onSelect(choices.find(d => d.id === target.value))
          }
          placeholder="Select options&hellip;"
          options={choices.reduce(
            (ret, d) => ({
              ...ret,
              [d.id]: `${d.drivetrain} ${d.engine} ${d.fuel_type} ${d.doors} door ${d.body}`,
            }),
            {},
          )}
        />
      )}
      <div className="tradepending-search-wrapper">
        <TextField
          rounded
          required
          label="How many miles does it have?"
          value={mileage}
          leftIcon="tachometer-alt"
          className="trade-pending"
          disabled={hasNoTrade}
          onFocus={({ target }) => target.select()}
          onChange={({ target }) => setMileage(target.value)}
          onBlur={() =>
            updateTrade(
              tradeIndex,
              { mileage },
              { dontChangeQuote: true, createChangeEvent },
            )
          }
        />
      </div>
      {children}
    </div>
  )
}

function mapStateToProps(state, op) {
  let trade = getQuoteValue(
    state,
    op.vehicleId,
    op.quoteId,
    `trades[${op.tradeIndex}]`,
    {},
  )

  return {
    ...op,
    trade,
    ymmt: getYMMT(trade),
    tpData: get(trade, 'tradePending', {}),
    dealerWebsite: getRooftopWebsite(state),
    hasNoTrade: getCustomerHasNoTrade(state),
    zipCode: getCustomerZip(state),
  }
}

export const TradePendingSearchNew = connect(
  mapStateToProps,
  { updateTrade },
)(TradePendingSearchNewPreso)
